import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

const PanelContent = (props, ref) => {
  const { prefixCls, forceRender, className, style, children, isActive, role } =
    props;
  const [rendered, setRendered] = useState(isActive || forceRender);
  useEffect(() => {
    if (isActive || forceRender) {
      setRendered(true);
    }
  }, [isActive, forceRender]);
  if (!rendered) {
    return null;
  }
  return (
    <div
      className={classnames(
        `${prefixCls}-content`,
        {
          [`${prefixCls}-content-active`]: isActive,
          [`${prefixCls}-content-inactive`]: !isActive
        },
        className
      )}
      style={style}
      role={role}
    >
      <div className={`${prefixCls}-content-box`}>{children}</div>
    </div>
  );
};

export default PanelContent;
